import ICardWidget from "./card/ICardWidget";
import IRestServiceFilters from "../api/IRestServiceFilters";
import IBackground from "../ui/IBackground";

export const CARD_RESERVED_NAMES = {
    EMPLOYEE_CARD: '#employee-card',
    MAP_CARD: '#map-card',
}

export default interface ICard{
    id?: number
    uuid: string
    name?: string
    label?: string
    route?: string
    widgets: ICardWidget[],
    contentType: string
    action?: string
    routePriority?: number
    conditions?: IRestServiceFilters
    background?: IBackground
}